import { useMutation } from 'react-query';
import { API } from 'api';
import { toastPush } from 'modules';
import { useDispatch } from 'react-redux';

export interface IPayoutPatchCompletedStatus {
  payload: {
    id: string;
    body: {
      paymentToBankId?: string;
      status: 'success' | 'rejected';
      systemErrorMessage?: string;
      providerErrorMessage?: string;
      bankErrorCode?: string;
      evidenceFile?: any;
      reason?: string;
    };
  };
  data: {
    success: boolean;
    data: any;
  };
}

const PayoutPatchCompletedStatus = (payload: IPayoutPatchCompletedStatus['payload']) => {
  const formData = new FormData();
  formData.append('evidenceFile', payload.body.evidenceFile || '');
  formData.append('status', payload.body.status);
  formData.append('bankErrorCode', payload.body.bankErrorCode || '');
  formData.append('paymentToBankId', payload.body.paymentToBankId || '');
  formData.append('reason', payload.body.reason || '');
  formData.append('systemErrorMessage', payload.body.systemErrorMessage || '');
  formData.append('providerErrorMessage', payload.body.providerErrorMessage || '');
  return API.newPost(`/api/admin/v1/payout/${payload.id}/patch-completed-status`, formData, {
    'Content-Type': 'multipart/form-data',
  });
};

export const usePayoutPatchCompletedStatus = () => {
  const dispatch = useDispatch();
  return useMutation(PayoutPatchCompletedStatus, {
    onSuccess: async (data) => {
      const result = data.data;
      if (result.success) {
        dispatch(
          toastPush({
            code: 200,
            type: 'success',
            title: 'SUCCESS',
            body: 'toastPush.updatedSuccessful',
          })
        );
        return true;
      }
      return false;
    },
  });
};
